import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/openid': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M271.5 432l-68 32c-115-10.3-203.5-71.5-203.5-145.8 0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384h0.1zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/openid.js
// module id = 954
// module chunks = 0